import { cn } from '@/lib/utils';
import { FC } from 'react';
import { InputProps, withField } from '../withField';

interface ToggleProps {
  id?: string;
  onChange?: (newValue: boolean) => void;
}

const ToggleInput: FC<InputProps<boolean> & ToggleProps> = ({ id, value, onChange }) => {
  return (
    <label className="flex items-center cursor-pointer">
      <div className="relative">
        <input
          id={id}
          checked={value}
          type="checkbox"
          className="sr-only"
          onChange={onChange ? () => onChange(!value) : event => event.preventDefault()}
        />
        <div
          className={cn('w-9 h-3 lg:w-10 lg:h-4 rounded-full shadow-inner', value ? 'bg-primary-700' : 'bg-gray-200')}
        ></div>
        <div
          className={cn(
            `dot absolute w-5 h-5 lg:w-6 lg:h-6 bg-gray-100 rounded-full shadow`,
            value ? '-right-1' : '-left-1',
            `-top-1 transition`
          )}
        ></div>
      </div>
    </label>
  );
};

export const ToggleField = withField<boolean, ToggleProps>(ToggleInput);
